import updateDocumentData from "../../../utils/updateDocumentData";

import { ProductionTodo } from "../types/ProductionTodo";

export default function updateProductionTodo(firebase, { todo, ...data }) {
	return todo.ref.update(ProductionTodo.partial().parse(updateDocumentData(firebase, data)));
}
